import { z } from 'zod';
import { IdSchema, ListQuerySchema, PageInfoSchema, TimestampSchema, VersionSchema, } from './common.js';
/**
 * Restoration-edition loss event (specification 8.7). One per job file; begins during intake
 * and remains the same record after conversion. Requires the `loss_events` capability.
 */
export const LossEventSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    jobFileId: IdSchema,
    propertyId: IdSchema.nullable(),
    lossTypeId: IdSchema.nullable(),
    occurredAt: TimestampSchema.nullable(),
    discoveredAt: TimestampSchema.nullable(),
    reportedAt: TimestampSchema,
    cause: z.string().nullable(),
    description: z.string().nullable(),
    affectedAreas: z.array(z.string()),
    emergency: z.boolean(),
    emergencyFlaggedAt: TimestampSchema.nullable(),
    source: z.string().nullable(),
    version: VersionSchema,
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
const AffectedAreasSchema = z.array(z.string().trim().min(1).max(100)).max(50);
export const CreateLossEventRequestSchema = z.strictObject({
    jobFileId: IdSchema,
    /** Defaults to the job file's property. */
    propertyId: IdSchema.nullable().default(null),
    lossTypeId: IdSchema.nullable().default(null),
    occurredAt: TimestampSchema.nullable().default(null),
    discoveredAt: TimestampSchema.nullable().default(null),
    reportedAt: TimestampSchema.optional(),
    cause: z.string().trim().max(500).nullable().default(null),
    description: z.string().trim().max(10_000).nullable().default(null),
    affectedAreas: AffectedAreasSchema.default([]),
    emergency: z.boolean().default(false),
    source: z.string().trim().max(100).nullable().default(null),
});
export const UpdateLossEventRequestSchema = CreateLossEventRequestSchema.omit({
    jobFileId: true,
    emergency: true,
})
    .partial()
    .extend({ version: VersionSchema });
/** Emergency is an independently audited priority flag, never a status substitute. */
export const EmergencyCommandSchema = z.strictObject({
    reason: z.string().trim().max(500).optional(),
    version: VersionSchema,
});
export const LossEventListQuerySchema = ListQuerySchema.extend({
    jobFileId: IdSchema.optional(),
    propertyId: IdSchema.optional(),
    lossTypeId: IdSchema.optional(),
    emergency: z.stringbool().optional(),
});
export const LossEventListSchema = z.strictObject({
    items: z.array(LossEventSchema),
    page: PageInfoSchema,
});
